<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" scrollable>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('audit_items_import_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <p>
            {{ $t('audit_items_import_standard') }}:
            <span
              :title="auditStandard.description"
            >{{auditStandard.name}}</span>
          </p>
          <p>Die CSV Datei muss Überschriften für die Felder enthalten.</p>
          <p>
            Nutzbare Felder
            <br />* - Erforderliche Felder
          </p>
          <ul>
            <li>
              <code>text</code>* - Text der Frage
            </li>
            <li>
              <code>hint</code> - Beschreibung zur Frage
            </li>
            <li>
              <code>chapter_id</code> - Zuordnungen der Frage zu Kapiteln im Standard. Zuordnungen zu mehreren Kapiteln möglich. z.B. "4.1,5.2"
            </li>
            <li>
              <code>category_id</code> - Id der Kategorie welcher die Frage zugeordnet werden soll.
            </li>
            <li>
              <code>category</code> - Kategorie welcher die Frage zugeordnet werden soll.
            </li>
            <li>
              <code>weight</code> - Gewichtung der Frage z.B. 0, 4, 6, 10
            </li>
            <li>
              <code>no</code> - Nummer der Frage
            </li>
          </ul>
          <ul>
            <li>questionCount: {{questionCount}}</li>
            <li>
              <v-textarea
                outline
                v-model="foundCategoriesExport"
                placeholder="{}"
                label="Gefundene Kategorien"
                required
              ></v-textarea>
            </li>
            <li v-if="parseErrors && parseErrors.length">parseErrors: {{parseErrors}}</li>
            <li
              v-if="unmappedChapterIds && unmappedChapterIds.length"
            >unmappedChapterIds: {{unmappedChapterIds}}</li>
          </ul>

          <input
            ref="csvUpload"
            type="file"
            accept=".csv"
            label="Csv-Upload"
            @change="onFilePicked"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn @click.native="importCurrentAuditItems">{{ $t('import_audit_items') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<i18n>
  {
    "de": {
      "audit_import_title" : "Audit-Fragenlisten Import",
      "import_standard" : "Importieren",
      "description_label" : "Beschreibung",
      "audits_label" : "Audit Metadaten",
      "audits_placeholder" : "JSON [\n { \"name\" : \"Audit Name\", \"standard\" : \"ISO9001\",\n ...\n]\noder CSV:\n\"Audit Name\";\"ISO9001\"",
      "field_required" : "Feld darf nicht leer sein",
      "audit_items_import_standard": "Standard"
    },
    "en": {
    }
  }
</i18n>

<script>
import Papa from "papaparse";

import { mapActions } from "vuex";
import { api } from "@/store/modules/templates";
import uuid from "uuid";

export default {
  props: {
    dialog: {
      default: false
    },
    currentAudit: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      questionCount: null,
      unmappedChapterIds: null,
      foundCategorys: null,
      parseErrors: null,
      foundCategoriesExport: null,
      parseCsv: null,
      importdata: {
        valid: false,
        audit_items: null
      }
    };
  },
  computed: {
    auditStandard() {
      if (this.currentAudit.standard) {
        const standard = this.$store.state.standards.loadedStandards[
          this.currentAudit.standard
        ];
        console.log("Standard", standard);
        if (standard) {
          return standard;
        }
      }
      return {
        name: "Unbekannt",
        description: "Unbekannt",
        chapters: [],
        id: null
      };
    }
  },
  methods: {
    ...mapActions(api.namespace, [api.actions.createAuditItem]),
    onParseComplete(Results) {
      if (Results.errors.length > 0) {
        this.questionCount = null;
        this.unmappedChapterIds = null;
        this.foundCategorys = null;
        this.parseErrors = Results.errors;
        this.foundCategoriesExport = "";
      } else {
        this.questionCount = Results.data.length;
        this.unmappedChapterIds = [];
        this.foundCategorys = [];
        this.parseErrors = [];
        this.importdata.audit_items = this.createAuditItems(Results.data);
        console.log("AuditItems", Results.data, this.importdata.audit_items);
        this.foundCategoriesExport = JSON.stringify(
          {
            [this.auditStandard.id]: this.foundCategorys
          },
          undefined,
          2
        );
      }
    },
    async onFilePicked(event) {
      let file = event.target.files[0];

      Papa.parse(file, {
        header: true,
        delimiter: ";",
        dynamicTyping: false,
        encoding: "utf-8",
        skipEmptyLines: true,
        complete: results => {
          console.log("Resultat", results);
          this.onParseComplete(results);
        },
        transform: (value, column) => {
          //console.log(column, value)
          if (column == "chapter_id") {
            return value.split(",").map(v => v.trim());
          } else {
            return value.trim();
          }
        }
      });
    },
    close() {
      this.$emit("update:dialog", false);
    },
    extractCategory(CategoryItem) {
      let category_id = CategoryItem.category_id || null;
      let category = CategoryItem.category || null;

      if (typeof category_id == "string" && typeof category == "string") {
        const idx = this.foundCategorys.findIndex(value => {
          return value.id == category_id;
        });

        if (idx < 0) {
          this.foundCategorys.push({
            id: category_id,
            name: category
          });
        } else {
          console.assert(
            this.foundCategorys[idx].name === category,
            "Expect category name matches ",
            this.foundCategorys[idx],
            category_id,
            category
          );
        }
      } else if (category_id === null && typeof category == "string") {
        const idx = this.foundCategorys.findIndex(value => {
          return value.name == category;
        });

        if (idx < 0) {
          category_id = uuid.v4();
          this.foundCategorys.push({
            id: category_id,
            name: category
          });
        } else {
          category_id = this.foundCategorys[idx].id;
        }
      } else {
        category_id = null;
      }

      return category_id;
      // {
      //   [this.auditStandard.id || "unknown"]: []
      // };
    },
    checkChapter(ChapterIds) {
      const chapters = [];
      if (ChapterIds instanceof Array) {
        for (const chapter_id of ChapterIds) {
          const chapter_idx = this.auditStandard.chapters.findIndex(Item => {
            return Item.id.trim() == chapter_id;
          });

          if (chapter_idx < 0) {
            if (/^\d+(\.\d+)+$/.test(chapter_id)) {
              this.unmappedChapterIds.push({
                msg: "Chapter Id unmappable",
                id: chapter_id,
                list: ChapterIds
              });
              chapters.push({
                id: chapter_id,
                standard: this.auditStandard.id,
                description: `Kapitel: ${chapter_id}`
              });
            }
          } else {
            chapters.push({
              id: this.auditStandard.chapters[chapter_idx].id,
              standard: this.auditStandard.id,
              description: this.auditStandard.chapters[chapter_idx].description
            });
          }
        }
      }

      return chapters;
    },
    importItem2AuditItem(ImportItem, idx) {
      const category = this.extractCategory(ImportItem);
      const chapters = this.checkChapter(ImportItem.chapter_id);
      const text =
        ImportItem.text && ImportItem.text.length > 0 ? ImportItem.text : null;
      const hint =
        ImportItem.hint && ImportItem.hint.length > 0 ? ImportItem.hint : null;
      const importance =
        ImportItem.weight && /^\d+$/.test(ImportItem.weight)
          ? ImportItem.weight
          : "1";
      const no =
        ImportItem.no && /^\d+(\.\d+)*[a-zA-Z]*$/.test(ImportItem.no)
          ? ImportItem.no
          : String(idx);

      if (text) {
        return {
          question: {
            importance,
            chapters,
            text,
            hint,
            category,
            no
          }
        };
      }
      console.log("importItem2AuditItem", ImportItem);
      return null;
    },
    createAuditItems(ImportData) {
      const audit_items = [];
      for (const [idx, import_item] of ImportData.entries()) {
        const audit_item = this.importItem2AuditItem(import_item, idx);
        if (audit_item) {
          audit_items.push(audit_item);
        } else {
          console.log("createAuditItems", audit_item, import_item, idx);
          this.parseErrors.push({
            msg: "Invalid CSV Row ignored",
            data: import_item,
            row: idx + 1
          });
        }
      }
      return audit_items;
    },

    importCurrentAuditItems() {
      if (
        this.importdata.audit_items &&
        this.importdata.audit_items.length > 0
      ) {
        const payload = {
          audit_id: this.currentAudit.id,
          data: this.importdata.audit_items
        };

        console.log("Before sending", payload);

        this.createAuditItem(payload)
          .then(success => {
            console.log("ImportData: OK", success);
            this.close();
          })
          .catch(reason => {
            console.log("ImportData: Failed", reason);
          });
      } else {
        console.log("ImportData: Invalid");
      }
    }
  }
};
</script>
